module.exports = __webpack_public_path__ + "static/img/sharebj1.6c7ab7a.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/sharebj1.png
// module id = EZC6
// module chunks = 22